import i18next from 'i18next';

import { formatNumberToExcelUsage } from '@commons/DisplayNumber';
import { getClientStoreNameTranslation } from '@commons/utils/translations';

export default ({ isCentral, storeName, displayPackagingWeight, displayInvoiceColumns }) => {
  const columns = [
    {
      name: i18next.t('ORDERS.ORDERS.LIST_LABEL_REFERENCE'),
      propertyKey: 'reference',
    },
    {
      name: getClientStoreNameTranslation(storeName),
      propertyKey: 'store.name',
    },
    {
      name: i18next.t(isCentral ? 'GENERAL.CENTRAL' : 'ORDERS.ORDERS.LIST_LABEL_SUPPLIER'),
      propertyKey: 'supplier.name',
    },
    {
      name: i18next.t('ORDERS.ORDERS.LIST_LABEL_DELIVERY_DATE'),
      propertyKey: 'startOrderDate',
    },
    {
      name: i18next.t('ORDERS.ORDERS.LIST_LABEL_CREATION_DATE'),
      propertyKey: 'orderDate',
    },
    {
      name: i18next.t('ORDERS.ORDERS.LIST_LABEL_STATUS'),
      propertyKey: isCentral ? 'preparationStatus' : 'status',
    },
    {
      name: i18next.t('ORDERS.ORDERS.EXPORT_TOTAL_HT_BDC'),
      propertyKey: 'totalPriceBDC',
      type: 'currency',
      transform: (value) => (value == null ? null : formatNumberToExcelUsage(value, 4)),
    },
    {
      name: i18next.t('ORDERS.ORDERS.EXPORT_TOTAL_HT_BDL'),
      propertyKey: 'totalPriceBDL',
      type: 'currency',
      transform: (value) => (value == null ? null : formatNumberToExcelUsage(value, 4)),
    },
    {
      name: i18next.t('ORDERS.ORDERS.EXPORT_TOTAL_BDC_INCL_TAXES'),
      propertyKey: 'totalPriceBDCInclTaxes',
      type: 'currency',
      transform: (value) => (value == null ? null : formatNumberToExcelUsage(value, 4)),
    },
    {
      name: i18next.t('ORDERS.ORDERS.EXPORT_TOTAL_BDL_INCL_TAXES'),
      propertyKey: 'totalPriceBDLInclTaxes',
      type: 'currency',
      transform: (value) => (value == null ? null : formatNumberToExcelUsage(value, 4)),
    },
  ];

  if (!isCentral) {
    const statusColumnIndex = columns.findIndex(({ propertyKey }) => propertyKey === 'status');

    columns.splice(statusColumnIndex + 1, 0, {
      name: i18next.t('ORDERS.ORDERS.EXPORT_BDL_NUMBER'),
      propertyKey: 'receptionReference',
    });

    const columnTotalPriceBDLindex = columns.findIndex(
      ({ propertyKey }) => propertyKey === 'totalPriceBDL',
    );

    columns.splice(columnTotalPriceBDLindex + 1, 0, {
      name: i18next.t('ORDERS.ORDERS.EXPORT_TOTAL_HT_RECEIVED'),
      propertyKey: 'totalPriceReceived',
      type: 'currency',
      transform: (value) => (value == null ? null : formatNumberToExcelUsage(value, 4)),
    });

    const columnTotalPriceBDCInclTaxesIndex = columns.findIndex(
      ({ propertyKey }) => propertyKey === 'totalPriceBDLInclTaxes',
    );

    columns.splice(columnTotalPriceBDCInclTaxesIndex + 1, 0, {
      name: i18next.t('ORDERS.ORDERS.EXPORT_TOTAL_RECEIVED_INCL_TAXES'),
      propertyKey: 'totalPriceReceivedInclTaxes',
      type: 'currency',
      transform: (value) => (value == null ? null : formatNumberToExcelUsage(value, 4)),
    });
  }

  if (displayPackagingWeight) {
    columns.push({
      name: i18next.t('ORDERS.ORDERS.EXPORT_TOTAL_WEIGHT'),
      propertyKey: 'totPackagingWeight',
    });
  }

  if (displayInvoiceColumns) {
    columns.push({
      name: i18next.t('INVOICE.INVOICE_CONTROL_DETAILS.FORM_INFORMATION_INVOICE_NUMBER_FIELD'),
      propertyKey: 'invoiceNumber',
    });

    columns.push({
      name: i18next.t('INVOICE.INVOICE_CONTROL_DETAILS.FORM_INFORMATION_INVOICE_DATE_FIELD'),
      propertyKey: 'invoiceDate',
    });

    columns.push({
      name: i18next.t(
        'INVOICE.INVOICE_CONTROL_DETAILS.FORM_INFORMATION_INVOICE_TOTAL_EXPORT_FIELD',
      ),
      propertyKey: 'invoiceTotal',
    });
  }

  return columns;
};
